module.exports = __webpack_public_path__ + "static/media/logo-icon.f386cdb4.jpg";